import { type UseMutationResult } from '@tanstack/react-query';

import { useApiMutation } from '../../../lib/api/hooks.js';
import { propertySetupEndpoints } from './endpoints.js';
import { type PropertySetupFormInput } from './schemas.js';

export interface UpdatePropertySetupVariables {
  readonly propertyId: string;
  readonly values: PropertySetupFormInput;
}

function normaliseId(value: string): string | null {
  return value === '' ? null : value;
}

export function useUpdatePropertySetup(): UseMutationResult<
  unknown,
  unknown,
  UpdatePropertySetupVariables
> {
  return useApiMutation<UpdatePropertySetupVariables, unknown>({
    mutationFn: async (api, { propertyId, values }) => {
      const selected = Object.entries(values.selectedAmenities)
        .filter(([, checked]) => checked)
        .map(([amenityId]) => ({
          amenityId,
          isFree: values.amenityFree[amenityId] ?? true,
        }));

      await api.put(propertySetupEndpoints.setup(propertyId), {
        configuration: {
          facebookUrl: values.facebookUrl,
          instagramUrl: values.instagramUrl,
          twitterUrl: values.twitterUrl,
          totalRooms: Number(values.totalRooms),
          smtpGatewayId: normaliseId(values.smtpGatewayId),
          smsGatewayId: normaliseId(values.smsGatewayId),
          paymentGatewayId: normaliseId(values.paymentGatewayId),
        },
        amenities: selected,
      });
    },
    invalidate: [['property-setup']],
  });
}
